import {CALL_API} from 'redux-api-middleware';
import {
  API_COMMENT_GET_REQUEST,
  API_COMMENT_GET_SUCCESS,
  API_COMMENT_GET_FAILURE,
  API_COMMENT_POST_REQUEST,
  API_COMMENT_POST_SUCCESS,
  API_COMMENT_POST_FAILURE,
} from 'common/types';
import {ENTITY_PAGE_TYPE_GRANT} from 'app-ui-componentlibrary/dist/common/constants';
import {ENDPOINT_COMMENT} from 'common/endpoints';
import _ from 'lodash';
import goStore from 'go/store';
import {getInfo} from 'common/storeUtils';
import {commonJwtHeader} from 'common/utils';

export default {
  saveCommentWithOrgId: (
    token,
    author,
    subject,
    internalComment,
    grantId,
    programId,
    organizationId,
    entityType
  ) => {
    let pgmId = _.toNumber(programId);
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_COMMENT}`,
        headers: commonJwtHeader(),
        body: JSON.stringify({
          author,
          subject,
          internalComment,
          grantId,
          programId: pgmId,
          organizationId,
          entityType,
        }),
        method: 'POST',
        types: [
          API_COMMENT_POST_REQUEST,
          API_COMMENT_POST_SUCCESS,
          API_COMMENT_POST_FAILURE,
        ],
      },
    };
  },
  saveSubComment: (
    token,
    author,
    subject,
    internalComment,
    entityId,
    programId,
    entityType,
    organizationId
  ) => {
    let pgmId = _.toNumber(programId);
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_COMMENT}`,
        headers: commonJwtHeader(),
        body: JSON.stringify({
          author,
          subject,
          internalComment,
          entityId,
          programId: pgmId,
          entityType,
          organizationId,
        }),
        method: 'POST',
        types: [
          API_COMMENT_POST_REQUEST,
          API_COMMENT_POST_SUCCESS,
          API_COMMENT_POST_FAILURE,
        ],
      },
    };
  },
  saveComment: (
    token,
    author,
    subject,
    internalComment,
    grantId,
    programId,
    entityType
  ) => {
    let pgmId = _.toNumber(programId);
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_COMMENT}`,
        headers: commonJwtHeader(),
        body: JSON.stringify({
          author,
          subject,
          internalComment,
          grantId,
          programId: pgmId,
          entityType,
        }),
        method: 'POST',
        types: [
          API_COMMENT_POST_REQUEST,
          API_COMMENT_POST_SUCCESS,
          API_COMMENT_POST_FAILURE,
        ],
      },
    };
  },
  // phase and task are optional, grantId is not
  getCommentsForGrant: (token, grantId, phase, task) => {
    const {baseUrl: endPointBase} = getInfo(goStore.store.getState(), ENDPOINT_COMMENT);
    return {
      [CALL_API]: {
        endpoint:
          `${endPointBase}` +
          `?grantId=${grantId}&entityType=${ENTITY_PAGE_TYPE_GRANT}&phase=${
            phase || ''
          }&task=${task || ''}`,
        method: 'GET',
        headers: commonJwtHeader(),
        types: [
          API_COMMENT_GET_REQUEST,
          API_COMMENT_GET_SUCCESS,
          API_COMMENT_GET_FAILURE,
        ],
      },
    };
  },
};
